import _ from 'lodash'
import { SelectionMode } from './config'

/**
 * 组件统一数据管理
 */
export default {
  data() {
    return {
      context: null,
      data: [],
      seedColumns: [],
      columns: [],
      hoverCell: null,
      innerSelection: [],
    }
  },
  computed: {
    selectionMode() {
      return this.context && this.context.selectionMode
    },
    selection() {
      return this.context && this.context.selection
    },
    selectableData() {
      return this.context && this.context.selectableData
    },
    innerSelectableData() {
      if (this.selectableData) {
        return this.selectableData
      }
      return this.data
    },
    checkOnSelect() {
      return this.context && this.context.checkOnSelect
    },
    isEmpty() {
      return !this.data || this.data.length === 0
    },
  },
  watch: {
    seedColumns(value) {
      this.columns = value
    },
    selectionMode(value, oldValue) {
      const fromMulti2Single = oldValue === SelectionMode.Multiple && value === SelectionMode.Single
      // const fromSingle2Multi = oldValue === SelectionMode.Single && value === SelectionMode.Multiple

      if (fromMulti2Single) {
        this.innerSelection = this.innerSelection[0] ? [this.innerSelection[0]] : []
      }
    },
    selection(value) {
      if (this.selectionMode === SelectionMode.Single) {
        if (!value) {
          this.innerSelection = []
        } else if (value !== this.innerSelection[0]) {
          this.innerSelection = [value]
        }
      } else if (this.selectionMode === SelectionMode.Multiple) {
        this.innerSelection = value
      }
    },
    innerSelection() {
      if (this.selectionMode === SelectionMode.Single) {
        this.$emit('selectionChange', this.innerSelection[0])
      } else if (this.selectionMode === SelectionMode.Multiple) {
        this.$emit('selectionChange', this.innerSelection)
      }
    },
    innerSelectableData() {
      // assure that innerSection is a sub set of selectableData
      this.innerSelection = _.filter(this.innerSelection, selectionData => _.includes(this.selectableData, selectionData))
    },
  },
  methods: {
    apiAddColumn(column) {
      this.seedColumns.push(column)
    },
    apiRemoveColumn(column) {
      const index = _.findIndex(this.seedColumns, column)
      this.seedColumns.splice(index, 1)
    },
    apiHandleHeaderCheckboxClick() {
      const currentChecked = this.innerSelection.length === this.innerSelectableData.length
      if (currentChecked) {
        this.innerSelection = []
      } else {
        this.innerSelection = _.clone(this.innerSelectableData)
      }
    },
    apiHandleRowClick(row, fromCheckbox = false) {
      const rowData = row.rowData

      if (!fromCheckbox && !this.checkOnSelect) {
        return
      }

      const selectable = _.includes(this.innerSelectableData, rowData)
      if (!selectable) {
        return
      }

      if (this.selectionMode === SelectionMode.Multiple) {
        const index = this.innerSelection.indexOf(rowData)
        const has = index !== -1

        if (has) {
          this.innerSelection.splice(index, 1)
        } else {
          this.innerSelection.push(rowData)
        }
      } else if (this.selectionMode === SelectionMode.Single) {
        if (this.innerSelection.length && this.innerSelection[0] === rowData) {
          this.innerSelection = []
        } else {
          this.innerSelection = [rowData]
        }
      }
    },
  },
}
